<script lang="ts">
	import { ShieldExclamationS } from '@svg';

	export let title: string | undefined = undefined,
		width: string | undefined = undefined,
		padding: string | undefined = undefined,
		dangerType: boolean = false;
</script>

<div
	class="bg-surface-100-800-token space-y-4 rounded-container-token shadow-xl max-h-[95vh] overflow-y-auto
    {width || 'w-modal'} {padding || 'p-4'}
  "
>
	{#if title}
		<h3 class="flex items-center gap-2 h3 {dangerType && 'text-error-500'}">
			{#if dangerType}
				<ShieldExclamationS />
			{/if}
			{title}
		</h3>
	{/if}

	<slot />
</div>
